import { useMemo } from 'react';
import * as yup from 'yup';

const useAccountManagersFormValidationSchema = () => useMemo(() => yup.object({}), []);

export default useAccountManagersFormValidationSchema;
